import { isValidElement } from 'react';
import PropTypes from 'prop-types';

function RenderGenericChildren({ children }) {
  const T = children;
  if (!T) return null;
  if (isValidElement(T)) return T;
  if (typeof T === 'function') return T();
  throw new Error(`invalid children type`);
}

RenderGenericChildren.propTypes = {
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.func]).isRequired,
};

export default RenderGenericChildren;
